/**
 * Retry calling the given callback a few times if it throws an error that "shouldRetry" returns true for.
 */
export async function retry<Result>(
  callback: (data: { attempt: number }) => Promise<Result>,
  shouldRetry: (err: Error) => boolean = () => true,
  attempts = 3
): Promise<Result> {
  for (let attempt = 1; attempt <= attempts; attempt++) {
    try {
      return await callback({ attempt });
    } catch (err: any) {
      if (!shouldRetry(err) || attempt === attempts) {
        throw err;
      }
    }
  }
  throw new Error('Retry loop exceeded'); // Should never happen
}
